import React, { useState, useEffect } from "react";
import moment from "moment";
import Inputs from "../Inputs";
import "./PeriodSelector.scss";

const periodOptions = [
  {
    id: "24h",
    label: "Last 24 hours",
    value: moment().subtract(1, "days").startOf("day").toString(),
  },
  {
    id: "7d",
    label: "Last 7 days",
    value: moment().subtract(7, "days").startOf("day").toString(),
  },
  {
    id: "31d",
    label: "Last 31 days",
    value: moment().subtract(31, "days").startOf("day").toString(),
  },
  {
    id: "custom",
    label: "Custom range",
    value: "custom",
  },
  {
    id: "all",
    label: "All time",
    value: null,
  },
];

const PeriodSelector = ({ onApply, selectedPeriod = "all", isLastCard = false }) => {
  const [selectedOption, setSelectedOption] = useState(selectedPeriod);
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);
  const [isCustomExpanded, setIsCustomExpanded] = useState(false);

  useEffect(() => {
    if (selectedOption === "custom") {
      setIsCustomExpanded(true);
    } else {
      setIsCustomExpanded(false);
      setCustomStartDate(null);
      setCustomEndDate(null);
    }
  }, [selectedOption]);

  const handleOptionSelect = (optionId) => {
    setSelectedOption(optionId);
  };

  const handleApply = () => {
    if (selectedOption === "custom") {
      if (customStartDate && customEndDate) {
        const startMoment = moment(customStartDate).startOf('day');
        const endMoment = moment(customEndDate).endOf('day');
        
        if (startMoment.isAfter(endMoment)) {
          // Swap dates if start is after end
          onApply({
            type: "custom",
            startDate: endMoment.toString(),
            endDate: startMoment.toString(),
            label: `${moment(customEndDate).format('DD/MM/YYYY')} - ${moment(customStartDate).format('DD/MM/YYYY')}`
          });
        } else {
          onApply({
            type: "custom",
            startDate: startMoment.toString(),
            endDate: endMoment.toString(),
            label: `${moment(customStartDate).format('DD/MM/YYYY')} - ${moment(customEndDate).format('DD/MM/YYYY')}`
          });
        }
      }
    } else {
      const selectedPeriodOption = periodOptions.find(opt => opt.id === selectedOption);
      onApply({
        type: selectedOption,
        startDate: selectedPeriodOption.value || null,
        endDate: selectedPeriodOption.value ? moment().toString() : null,
        label: selectedPeriodOption.label
      });
    }
  };

  const isApplyDisabled = () => {
    if (selectedOption === "custom") {
      return !customStartDate || !customEndDate;
    }
    return false;
  };

  return (
    <div className={`period-selector-container ${isLastCard ? 'last-card-position' : ''}`}>
      <div className="period-options">
        {periodOptions.map((option) => (
          <div key={option.id} className="period-option-row">
            <div 
              className={`check-circle ${selectedOption === option.id ? 'selected' : ''}`}
              onClick={() => handleOptionSelect(option.id)}
            >
              {selectedOption === option.id && <div className="check-mark" />}
            </div>
            <span 
              className="option-label"
              onClick={() => handleOptionSelect(option.id)}
            >
              {option.label}
            </span>
          </div>
        ))}
      </div>

      {isCustomExpanded && (
        <div className="custom-date-inputs">
          <Inputs.DatePicker
            selected={customStartDate}
            onChange={setCustomStartDate}
            placeholderText="From"
            maxDate={customEndDate || new Date()}
          />
          <Inputs.DatePicker
            selected={customEndDate}
            onChange={setCustomEndDate}
            placeholderText="To"
            minDate={customStartDate}
            maxDate={new Date()}
          />
        </div>
      )}

      <button 
        className={`apply-button ${isApplyDisabled() ? 'disabled' : ''}`}
        onClick={handleApply}
        disabled={isApplyDisabled()}
      >
        APPLY
      </button>
    </div>
  );
};

export default PeriodSelector;
